import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function useSiteInteractions() {
  const { pathname } = useLocation();

  useEffect(() => {
    const nav = document.querySelector('.nav');
    let reveals = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    const counters = Array.prototype.slice.call(document.querySelectorAll('[data-count]'));
    const counted = new WeakSet();
    const intervals = [];
    const timeouts = [];
    const rafs = [];

    function inViewport(el, margin) {
      const r = el.getBoundingClientRect();
      const h = window.innerHeight || document.documentElement.clientHeight;
      return r.top < h - (margin || 0) && r.bottom > 0;
    }

    function animateCount(el) {
      const target = parseFloat(el.getAttribute('data-count'));
      const dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
      const dur = parseInt(el.getAttribute('data-dur') || '1800', 10);
      const start = performance.now();
      function tick(now) {
        const p = Math.min((now - start) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        const val = target * eased;
        el.textContent = val.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
        if (p < 1) rafs.push(requestAnimationFrame(tick));
        else el.textContent = target.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
      }
      rafs.push(requestAnimationFrame(tick));
    }

    function checkReveals() {
      for (let i = reveals.length - 1; i >= 0; i--) {
        if (inViewport(reveals[i], 60)) {
          reveals[i].classList.add('in');
          reveals.splice(i, 1);
        }
      }
      for (let j = 0; j < counters.length; j++) {
        if (!counted.has(counters[j]) && inViewport(counters[j], 40)) {
          counted.add(counters[j]);
          animateCount(counters[j]);
        }
      }
    }

    function onScroll() {
      if (nav) nav.classList.toggle('scrolled', window.scrollY > 40);
      const y = window.scrollY;
      document.querySelectorAll('[data-parallax]').forEach((el) => {
        const speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        el.style.transform = 'translate3d(0,' + (y * speed).toFixed(2) + 'px,0)';
      });
      checkReveals();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', checkReveals, { passive: true });
    onScroll();
    rafs.push(requestAnimationFrame(checkReveals));
    timeouts.push(setTimeout(checkReveals, 120));
    timeouts.push(setTimeout(checkReveals, 400));

    const tiltCards = [];
    document.querySelectorAll('[data-tilt]').forEach((card) => {
      const move = (e) => {
        const r = card.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5;
        const py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform =
          'perspective(900px) rotateX(' + (-py * 4).toFixed(2) + 'deg) rotateY(' + (px * 4).toFixed(2) + 'deg) translateY(-6px)';
      };
      const leave = () => { card.style.transform = ''; };
      card.addEventListener('pointermove', move);
      card.addEventListener('pointerleave', leave);
      tiltCards.push([card, move, leave]);
    });

    document.querySelectorAll('.hero-slides, .hero-a__slides').forEach((wrap) => {
      const slides = wrap.querySelectorAll('.hero-slide, .hero-a__slide');
      if (slides.length < 2) return;
      let i = 0;
      const id = setInterval(() => {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, 5000);
      intervals.push(id);
    });

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', checkReveals);
      intervals.forEach(clearInterval);
      timeouts.forEach(clearTimeout);
      rafs.forEach(cancelAnimationFrame);
      tiltCards.forEach(([card, move, leave]) => {
        card.removeEventListener('pointermove', move);
        card.removeEventListener('pointerleave', leave);
      });
    };
  }, [pathname]);
}
